<div class="card">
	<div class="card-header">
		<h1>Productos asociados <!-- <i (click)="showModalCreate = true" tooltip="Agregar Empresa Asociada"
				class="clickeable fa fa-circle-plus text-info"></i> --></h1>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="searchAssociatePartner" class="form-label">Buscar producto asociado </label>
			<input type="text" placeholder="Código, nombre" (input)="filter()"
				[(ngModel)]="filterAssociated" id="searchAssociatePartner" name="searchAssociatePartner"
				class="form-control">
		</div>
		<div class="row">
			<svg id="svg-container" #svgContainer></svg>
			<div class="col">
				<div class="table-responsive mt-3">
					<table class="table table-bordered" id="table-products" name="table-products"
						style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th>Código</th>
								<th>Nombre</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let product of paginationProducts.filter">
								<tr class="item tr-middle" (click)="selectRow(product)"
									[class.selected]="product.code == productOrigin">
									<td>{{product.code}}</td>
									<td>{{product.name}}</td>
									<td>
										<i
											[ngClass]="product.code == productOrigin?'fa-solid fa-circle':'fa-regular fa-circle'"></i>
									</td>
								</tr>
							</ng-container>
							<tr class="tr-middle" *ngIf="paginationProducts.total.length == 0">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> {{failedStart?
									'No se pudieron obtener los resultados, fallo en el servidor'
									:'No se encontraron resultados'}}
								</td>
							</tr>
							<tr class="tr-middle" *ngIf="paginationProducts.total.length != 0 
							&& paginationProducts.filter.length == 0 && filterAssociated">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> No se encontraron resultados para <b>{{filterAssociated}}</b>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom (changed)="productOrigin = null; drawLink();" [elements]="paginationProducts" [pageSizeElements]="[5, 10]"></app-pagination-custom>
			</div>
			<div class="col" style="padding-left: 4rem;">
				<div class="table-responsive mt-3">
					<table class="table table-bordered" id="table-associated" name="table-associated"
						style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th></th>
								<th>Código</th>
								<th>Nombre</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="productOrigin">
								<tr class="item tr-middle selected" *ngFor="let associate of associated">
									<td>
										<i class="fa-solid fa-circle"></i>
									</td>
									<td>
										{{associate.code}}
									</td>
									<td>
										{{associate.name}}
									</td>
								</tr>
							</ng-container>
							<tr class="tr-middle" *ngIf="associated.length == 0 || !productOrigin">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> Elige un producto primero
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>